<mat-dialog-content xmlns="http://www.w3.org/1999/html">
  <h2>{{"admin.countries.create" | translate}} {{"intelligence-reporting.questions.question" | translate}} {{"admin.templates.category" | translate}}</h2>
  <mat-card-content>
    <form (submit)="sendCreationRequest()" [formGroup]="questionCategoriesCreateForm" autocomplete="off">
      <div class="form-container">

        <mat-form-field appearance="fill">
          <mat-label>{{"admin.dialogs.description" |translate}}</mat-label>
          <input [formControl]="descriptionControl" matInput type="text">
        </mat-form-field>


        <div class="edit-dialog-buttons-container">
          <button mat-raised-button (click)="closeDialog()" type="button" >
            <span>Close</span>
          </button>
          <button [disabled]="questionCategoriesCreateForm.invalid" mat-raised-button color="primary" type="submit">
            <span>Save</span>
          </button>
        </div>
      </div>
    </form>
  </mat-card-content>
</mat-dialog-content>

